import { cardDimensions, cardDimensionsMedia } from '../assets/styles/themes/tokens';

const useCardDimensions = () => {
  return {
    ...cardDimensionsMedia,
    ...cardDimensions,
  };
};

export default useCardDimensions;
